import {
  CHUNKED_UPLOAD_MIN_SIZE,
  UPLOAD_BATCH_THRESHOLD
} from "@/js/upload/config";

// Upload strategy helpers decide which path to use for a given stack.
const shouldUseChunkedUploadForStack = (stack, options = {}) => {
  if (options.forceChunked) {
    return true;
  }
  if (stack.isMultiframe && stack.dataSet && stack.dataSet.byteArray) {
    return stack.dataSet.byteArray.length >= CHUNKED_UPLOAD_MIN_SIZE;
  }
  if (!stack.instances) {
    return false;
  }
  return Object.values(stack.instances).some(
    instance => instance.file && instance.file.size >= CHUNKED_UPLOAD_MIN_SIZE
  );
};

const shouldUseBatchUploadForStack = (stack, options = {}) => {
  if (options.forceBatch) {
    return true;
  }
  if (stack.isMultiframe) {
    return false;
  }
  const count = Array.isArray(stack.imageIds) ? stack.imageIds.length : 0;
  return count >= UPLOAD_BATCH_THRESHOLD;
};

export { shouldUseBatchUploadForStack, shouldUseChunkedUploadForStack };
